import { render, staticRenderFns } from "./KihuMoney_2.vue?vue&type=template&id=db4d344c&scoped=true"
import script from "./KihuMoney_2.vue?vue&type=script&lang=js"
export * from "./KihuMoney_2.vue?vue&type=script&lang=js"
import style0 from "./KihuMoney_2.vue?vue&type=style&index=0&id=db4d344c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4d344c",
  null
  
)

export default component.exports